import { useState, useEffect } from "react";
import { getPartnerActivationHistory } from "../apis";
import { useLocation, useParams } from "react-router-dom";
import CustomPagination from "./CustomPagination";

const ActivationHistory = () => {
  const location = useLocation();
  const { id } = useParams();
  const [activationHistoryData, setActivationHistoryData] = useState([]);
  const [paginator, setPaginator] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(
    parseInt(new URLSearchParams(location.search).get("page"), 10) || 1
  );
  useEffect(() => {
    setIsLoading(true);
    getPartnerActivationHistory(id, currentPage)
      .then((response) => {
        setActivationHistoryData(response.data?.data?.data || []);
        setPaginator({
          last_page: response.data.data.last_page,
          current_page: response.data.data.current_page,
        });
      })
      .catch((error) => {
        console.error("Failed to fetch activation history:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [id, currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  return (
    <section className="tw-container tw-mx-auto tw-p-5 tw-bg-white tw-rounded-[10px] tw-shadow-md">
      <h3 className="tw-text-xl tw-font-semibold tw-text-primary tw-mb-4 tw-border-b tw-pb-2">
        Activation History
      </h3>

      <div className="tw-overflow-x-auto">
        {isLoading ? (
          <p className="tw-text-center tw-py-4">Loading...</p>
        ) : activationHistoryData.length === 0 ? (
          <p className="tw-text-center tw-text-gray-500 tw-py-4">
            No activation history found.
          </p>
        ) : (
          <table className="tw-min-w-full tw-bg-white tw-rounded-lg tw-shadow-md">
            <thead>
              <tr className="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-whitespace-nowrap">
                <th className="tw-px-4 tw-py-2">Num</th>
                <th className="tw-px-4 tw-py-2">Date</th>
                <th className="tw-px-4 tw-py-2">Action By</th>
                <th className="tw-px-4 tw-py-2">Action Status</th>
                <th className="tw-px-4 tw-py-2">Reason</th>
                <th className="tw-px-4 tw-py-2">Note</th>
              </tr>
            </thead>
            <tbody>
              {activationHistoryData.map((data, index) => (
                <tr
                  key={index}
                  className="tw-border-b tw-border-gray-200 tw-whitespace-nowrap tw-text-sm tw-text-gray-500"
                >
                  <td className="tw-px-4 tw-py-2">{data.num}</td>
                  <td className="tw-px-4 tw-py-2">{data.created_at}</td>
                  <td className="tw-px-4 tw-py-2">{data.created_by}</td>
                  <td className="tw-px-4 tw-py-2">
                    {data.status === 1 ? "Active" : "Inactive"}
                  </td>
                  <td className="tw-px-4 tw-py-2">{data.reason ?? "-"}</td>
                  <td className="tw-px-4 tw-py-2">{data.notes ?? "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      <div className="flex justify-center mt-4">
        <CustomPagination
          totalPages={paginator?.last_page}
          currentPage={paginator?.current_page || 1}
          onPageChange={handlePageChange}
        />
      </div>
    </section>
  );
};

export default ActivationHistory;
